module.exports = __webpack_public_path__ + "img/hospital8.6ff72ed8.png";